import { Component, EventEmitter, Input, Output } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { UserService } from "src/app/_services";
import { DataRowComponent } from "../../../_component/pagination-client-side/data-row.component";

@Component({
  selector: 'app-group-view',
  templateUrl: './company-group-view.component.html',
  styleUrls: ['./company-group-view.component.scss',     "./../../../../_styles/ion-grid-content-table.scss",],
})
export class CompanyGroupViewComponent implements DataRowComponent  {

  @Input()
  row: any;

  @Input()
  displayMobileView = false;

  @Input()
  styleClass;
  
  @Input()
  customData

  @Output()
  refreshRequest: EventEmitter<any> = new EventEmitter<any>();

  @Output()
  actionRequest: EventEmitter<any> = new EventEmitter<any>();

  constructor(
    private userServ: UserService,
  ) {}

  checkPermission(companyId: number): Boolean {
    if (
      this.userServ.permissionEditCompany(
        companyId,
        ["company.edit"],
        ["company.edit.only-my-company"]
      )
    ) {
      return true;
    } else {
      return false;
    }
  }


  edit() {
    this.actionRequest.emit({
      type: "edit",
      companyGroup: this.row,
    });
  }

  delete($event) {
    $event.preventDefault();
    $event.stopPropagation();

    this.actionRequest.emit({
      type: "remove",
      id: this.row.id,
    });
  }

}
